export type GetNotificationsParams = {
  search?: string;
  page?: number;
  limit?: number;
  isPagination?: 1 | 0;
  order?: "ASC" | "DESC";
  orderBy?: "id" | "created_at";
  s?: string;
  inIds?: number[];
  notInIds?: number[];
  language?: string;
  startDate?: string;
  endDate?: string;
};

export enum NotificationStatus {
  DRAFT = "DRAFT",
  NOTIFIED = "NOTIFIED",
  READY = "READY",
}

export enum NotificationType {
  SCHEDULE = "SCHEDULE",
  REALTIME = "REALTIME",
}

export type Notification = {
  id: number;
  company_id: number | null;
  parent_id: number | null;
  creator_role: string | null;
  manager: string;
  title: string;
  description: string;
  type: NotificationType; // nếu có enum cụ thể thì thay string
  status: NotificationStatus; // tương tự, thay bằng union các trạng thái thực tế
  files: string[]; // nếu file có cấu trúc riêng thì tạo type cho nó
  send_time: string; // hoặc Date nếu bạn parse ra
  created_at: string;
  updated_at: string;

  notificationsCompany?: {
    company_id: number;
    company?: {
      name: string;
      id: number;
    };
  }[];
  notificationsGroup?: {
    group_id: number;
    group?: {
      name: string;
      id: number;
    };
  }[];
  notificationsStore?: {
    store_id: number;
    store?: {
      name: string;
      id: number;
    };
  }[];
  notificationsUser?: {
    user_id: number;
    user?: {
      user_id: number;
      // user?: User;
      full_name: string;
      id: number;
      email: string;
    };
  }[];
  attachments?: {
    id: number;
    name: string;
    url: string;
    type: string;
  }[];

  send_to_all_companies?: boolean;
  send_to_all_groups?: boolean;
  send_to_all_stores?: boolean;
  send_to_all_users?: boolean;
};

export type NewNotificationParams = {
  send_time: string;
  title: string;
  description?: string;
  manager?: string;
  status: NotificationStatus;
  companyIds?: number[];
  storeIds?: number[];
  groupIds?: number[];
  storeUserIds?: number[];
  send_to_all_companies?: number; // 1 or 0
  send_to_all_stores?: number; // 1 or 0
  send_to_all_groups?: number; // 1 or 0
  send_to_all_users?: number; // 1 or 0
  files?: number[];
  parentId?: number;
  file_urls?: string[];
};

export type MyNotificationDto = {
  status: MyNotiStatus;
  user_id: number;
  notification?: Notification;
  notification_id: number;
  updated_at: string;
  created_at: string;
  deleted_at: string;
};

export enum SendToAllEnum {
  ALL = 1,
  OPTIONAL = 2,
  NONE = 3,
}

export enum MyNotiStatus {
  READ = "READ",
  RECEIVED = "RECEIVED",
}

export type UpdateNotificationParams = NewNotificationParams & {
  deletedAttachments?: number[];
};
